import KDivider from "./KDivider.vue";
export default KDivider;
